/* /assets/cart-shipping-message.js
 *
 * Repairs the "left to spend for free shipping" amount that theme.js renders.
 *
 * theme.js formats the amount and then does .replace('.00', '') to drop empty
 * decimals. That is written for the 1,234.00 format. Our money format is
 * 1.234,00, where the same replace eats the thousands separator instead:
 *   2.001,00 Kc  ->  21,00 Kc
 * It only shows up when the remaining amount lands in a X.00Y group, which is
 * why it looks random. theme.js is vendor code we do not edit, so we recompute
 * the value and write it back.
 *
 * Liquid already renders the correct amount server side; theme.js overwrites it
 * on load, on every cart change, and again whenever it re-renders the cart
 * section (which swaps the element out entirely). So rather than patching the
 * element once, we watch a stable ancestor: MutationObserver callbacks run as
 * microtasks, i.e. in the same task as theme.js's write and before the browser
 * paints, so the wrong amount never reaches the screen.
 */
(function () {
  if (window.__cartShippingMessageFix) return;
  window.__cartShippingMessageFix = true;

  var MESSAGE = '[data-cart-message]';
  var AMOUNT = '[data-left-to-spend]';

  var SEPARATORS = {
    comma_separator: { thousands: '.', decimal: ',' },
    space_separator: { thousands: ' ', decimal: ',' },
    apostrophe_separator: { thousands: "'", decimal: '.' }
  };

  function separatorsFor(token) {
    for (var name in SEPARATORS) {
      if (token.indexOf(name) !== -1) return SEPARATORS[name];
    }
    return { thousands: ',', decimal: '.' };
  }

  // Mirrors Shopify's money_format tokens closely enough for the amounts we show.
  function formatMoney(cents, format) {
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var token = match ? match[1] : 'amount';
    var sep = separatorsFor(token);
    var value = cents / 100;
    var fixed = token.indexOf('no_decimals') !== -1 ? String(Math.round(value)) : value.toFixed(2);
    var parts = fixed.split('.');
    var integer = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep.thousands);
    var number = parts[1] ? integer + sep.decimal + parts[1] : integer;
    var stripEmptyDecimals = new RegExp('\\' + sep.decimal + '00(?=\\D*$)');

    return format.replace(/\{\{\s*\w+\s*\}\}/, number).replace(stripEmptyDecimals, '');
  }

  var cartTotal = null;
  var lastRenderedTotal = null;

  // A re-rendered section carries a fresh server-side total, so a changed
  // attribute is newer than whatever the last cart event told us.
  function syncCartTotal(holder) {
    var rendered = holder.getAttribute('data-cart-total');
    if (rendered === null) return;
    if (rendered !== lastRenderedTotal) {
      lastRenderedTotal = rendered;
      cartTotal = Number(rendered);
    } else if (cartTotal === null) {
      cartTotal = Number(rendered);
    }
  }

  function expectedFor(holder) {
    var presentment = holder.getAttribute('data-limit-presentment') === 'true';
    var rate = presentment ? 1 : Number((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1);
    var limit = Number(holder.getAttribute('data-limit')) * 100 * rate;
    var format = (window.theme && window.theme.moneyFormat) || '{{amount}}';
    var amount = formatMoney(limit - (cartTotal || 0), format);

    if (window.theme && window.theme.settings && window.theme.settings.currency_code_enable) {
      amount += ' ' + window.theme.currencyCode;
    }
    return amount;
  }

  var repainting = false;

  function repaint() {
    if (repainting) return;
    repainting = true;

    try {
      var holders = document.querySelectorAll(MESSAGE);
      for (var i = 0; i < holders.length; i++) {
        syncCartTotal(holders[i]);

        var target = holders[i].querySelector(AMOUNT);
        if (!target) continue;

        var expected = expectedFor(holders[i]);
        if (target.textContent.trim() !== expected.trim()) target.textContent = expected;
      }
    } finally {
      repainting = false;
    }
  }

  document.addEventListener('theme:cart:change', function (event) {
    if (event.detail && event.detail.cart) cartTotal = event.detail.cart.total_price;
    repaint();
  });

  new MutationObserver(repaint).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });

  repaint();
  document.addEventListener('DOMContentLoaded', repaint);
})();
